<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="上传附件" style="margin-right:15px">
        <el-upload
          :headers="headers"
          class="upload-demo"
          :action="uploadUrl"
          :before-remove="beforeRemove"
          :before-upload="beforeUploadFile"
          :on-success="handleSuccess"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">
            点击上传
          </el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="App名称" style="margin-right:15px">
        <el-input v-model="form.name" :disabled="true" />
      </el-form-item>
      <el-form-item label="App大小" style="margin-right:15px">
        <el-input v-model="form.size" :disabled="true" />
      </el-form-item>
      <el-form-item label="App类型" prop="type" style="margin-right:15px">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option label="司机端" value="tmsDriver" />
          <el-option label="托运人端" value="tmsShipper" />
          <el-option label="同城司机端" value="ctmsDriver" />
          <el-option label="同城托运人端" value="ctmsShipment" />
        </el-select>
      </el-form-item>
      <el-form-item label="App版本" prop="version" style="margin-right:15px">
        <el-input v-model="form.version" />
      </el-form-item>
      <el-form-item label="自动更新" style="margin-right:15px">
        <el-radio-group v-model="form.openUpdate">
          <el-radio :label="1">
            开启
          </el-radio>
          <el-radio :label="0">
            关闭
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="强制更新" style="margin-right:15px">
        <el-radio-group v-model="form.forceUpdate">
          <el-radio :label="1">
            开启
          </el-radio>
          <el-radio :label="0">
            关闭
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="更新内容" style="margin-right:15px">
        <el-input v-model="form.content" type="textarea" />
      </el-form-item>
      <el-form-item label="下载链接" prop="link" style="margin-right:15px">
        <el-input v-model="form.link" :disabled="true">
          <el-link
            slot="append"
            type="primary"
            :href="form.link"
            :underline="false"
            target="_blank"
          >
            <el-button v-model="form.link" type="primary">
              下载APP
            </el-button>
          </el-link>
        </el-input>
      </el-form-item>
      <el-form-item label="二维码" style="margin-right:15px">
        <el-image style="width: 200px; height: 200px" :src="form.qrCode" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import { AppUploadDetails, AppUploadAdd } from "@/api/statistics";
import { getToken } from "@/utils/auth";
export default {
  name: "PartyGroupConfigEdit",
  data() {
    return {
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
      headers: {
        Authorization: "Bearer " + getToken(),
        deviceId: "0000000000"
      },
      fileList: [],
      form: {
        id: "",
        name: "",
        type: "",
        size: "",
        sha1: "",
        link: "",
        qrCode: "",
        version: "",
        openUpdate: "",
        forceUpdate: "",
        content: ""
      },
      rules: {
        link: [{ required: true, message: "请上传文件", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        version: [
          { required: true, message: "请输入版本", trigger: "blur" },
          { max: 10, message: "最大长度不超过 10 个字符" }
        ],
        content: [
          { required: true, message: "请输入修改内容", trigger: "blur" },
          { max: 255, message: "最大长度不超过 255 个字符" }
        ],
        qrCode: [{ max: 120, message: "最大长度不超过 120 个字符" }]
      }
    };
  },
  created() {
    //保存空表单对象
  },
  methods: {
    // 获取页面信息
    getInfo(id) {
      this.$refs["form"].resetFields();
      //查询到数据之前先展示空表单
      AppUploadDetails(id).then(response => {
        this.form = response.data;
        this.loading = false;
      });
    },
    //提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          AppUploadAdd(this.form).then(response => {
            rLoading.close();
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.form = response.data;
            this.$emit("fatherEditMethod");
          });
        } else {
          return false;
        }
      });
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    },
    //上传前校验
    beforeUploadFile(file) {
      // 获取token值，实时获取
      this.headers.Authorization = "Bearer " + getToken();
      return true;
    },
    handleSuccess(res, file) {
      if (res.status == 500) {
        this.$message.error(res.msg);
      } else {
        this.$message({ message: res.msg, type: "success" });
        this.form.link = res.data;
        this.form.size = file.size;
        this.form.name = file.name;
        this.form.qrCode = res.data;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}

.el-date-editor {
  width: 100%;
}
</style>
